import React, { useContext } from 'react';
import { TranslationKey } from './../../../../../../../../types/translation/TranslationKey';
import { ProductTransaction } from '../../../../../../../../types/productTransaction';
import { Grid } from '@mui/material';
import { ProductMasterData } from '../../../../../../../../types/product_master_data/productMasterData';
import { t } from '../../../../../../../../types/translation/Translator';
import { Container } from '../../../../../../../../types/container';
import { ProductMasterDataContext } from '../../../../../../../../context/ProductMasterDataContext';
import { TextInput } from '../../../../../../../components/TextInput';
import { UnitOfMeasureUtil } from '../../../../../../../../types/uom';
import { System } from '../../../../../../../../types/system';

interface ProductTransactionQuantityProps {
  transaction: ProductTransaction;
  setTransaction: React.Dispatch<React.SetStateAction<ProductTransaction>>;

  productMasterData?: ProductMasterData;
  container?: Container;

  disabled?: boolean;
}

export default function ProductTransactionQuantity({
  transaction,
  setTransaction,
  productMasterData: pmd,
  container,
  disabled = false,
}: ProductTransactionQuantityProps) {
  const { productMasterData } = useContext(ProductMasterDataContext);

  if (!pmd) return null;

  return (
    <>
      {transaction.parentId ? (
        <Grid item xs={6}>
          <TextInput
            label={t(TranslationKey.expectedQuantity).singular.label}
            disabled
            onChange={() => {}}
            value={transaction.product.quantity.toString()}
            trailing={
              pmd
                ? UnitOfMeasureUtil.getSuffix(productMasterData.get(transaction.product.pmdId || '')?.unitOfMeasure)
                : undefined
            }
          />
        </Grid>
      ) : null}
      <Grid item xs={6}>
        <TextInput
          mandatory
          type='number'
          label={t(TranslationKey.processQuantity).singular.label}
          disabled={
            transaction.statusId === System.ProductTransactionStatus.completedId ||
            transaction.statusId === System.ProductTransactionStatus.cancelledId ||
            transaction.statusId === System.ProductTransactionStatus.rollbackId ||
            pmd.serialManaged ||
            disabled ||
            !!transaction.parentId
          }
          onChange={v => setTransaction(transaction => transaction.withProcessedQuantity(parseFloat(v) || 0))}
          value={transaction.product.processedQuantity?.toString()}
          trailing={UnitOfMeasureUtil.getSuffix(productMasterData.get(transaction.product.pmdId || '')?.unitOfMeasure)}
        />
      </Grid>
    </>
  );
}
